import React from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import * as Yup from 'yup';

import { educationLevels } from '@zr/common/js/profile/more-info-options';
import LabeledField from '@zr/components/Fields/LabeledField';

import FormActions from '../../../components/FormActions';
import QuestionLabel from '../../../components/QuestionLabel';

import IndexedLegend from './IndexedLegend';
import FormButtons from './FormButtons';

import { patchProfileForm } from './utilities';

const EDUCATION = 'education';

export function DegreeEarned({
  index, onContinue, onError, onSkip, submitButtonText, totalScreeningQuestions,
  isInJs6650Test, setIsLoading,
}) {
  const handleContinue = async (values, formik) => {
    // `setIsLoading(true)` so that we can disable the close button while the
    // screen is processing/loading
    setIsLoading(true);
    await patchProfileForm(values, formik, onContinue, onError);
  };

  return (
    <Formik
      initialValues={{ [EDUCATION]: '' }}
      onSubmit={handleContinue}
      validationSchema={Yup.object().shape({
        [EDUCATION]: Yup.string().required('Please select your degree'),
      })}
    >
      {({
        errors, handleChange, handleSubmit, isSubmitting, touched, values,
      }) => (
        <form className="Suggestion" onSubmit={handleSubmit}>
          <fieldset>
            {isInJs6650Test && (
              <QuestionLabel
                as="legend"
                html="Please select your highest educational degree earned."
                number={index}
                totalQuestions={totalScreeningQuestions}
              />
            )}
            {!isInJs6650Test && (
              <IndexedLegend index={index} text="Please select your highest educational degree earned." />
            )}
            <LabeledField
              as="select"
              input={{
                disabled: isSubmitting,
                name: EDUCATION,
                onChange: handleChange,
                value: values[EDUCATION],
              }}
              label="Highest Degree Earned"
              meta={{
                error: errors[EDUCATION],
                touched: touched[EDUCATION],
              }}
              placeholder="Highest Degree Earned"
            >
              {educationLevels.map((edu) => <option key={edu.value} value={edu.value}>{edu.text}</option>)}
            </LabeledField>
            {isInJs6650Test && (
              <FormActions
                disableContinue={isSubmitting}
                disableSkip={isSubmitting}
                onSkip={onSkip}
                submitButtonText={submitButtonText}
              />
            )}
            {!isInJs6650Test && (
              <FormButtons disabled={isSubmitting} onSkip={onSkip} submitButtonText={submitButtonText} />
            )}
          </fieldset>
        </form>
      )}
    </Formik>
  );
}

DegreeEarned.propTypes = {
  index: PropTypes.number.isRequired,
  isInJs6650Test: PropTypes.bool,
  onContinue: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  onSkip: PropTypes.func,
  setIsLoading: PropTypes.func,
  submitButtonText: PropTypes.string,
  totalScreeningQuestions: PropTypes.number.isRequired,
};

DegreeEarned.defaultProps = {
  isInJs6650Test: false,
  onSkip: null,
  setIsLoading: () => {},
  submitButtonText: 'Continue',
};

export default DegreeEarned;
